import { render, staticRenderFns } from "./VAdvertsPopover.vue?vue&type=template&id=1ccb0853&"
import script from "./VAdvertsPopover.vue?vue&type=script&lang=js&"
export * from "./VAdvertsPopover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports